import React, { useEffect } from 'react';
import '@assets/page/ScrollTop.scss';

const HiddenElement = ({ children }) => {
  let styled;

  useEffect(() => {
    if (navigator.userAgent === 'ReactSnap') {
      styled = { display: 'none' };
    }
  });

  return (
    <React.Fragment>
      <div style={styled}>{children}</div>
    </React.Fragment>
  );
};

export default HiddenElement;
